/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconItalic = createReactComponent("italic", "IconItalic", [
  ["path", { d: "M11 5l6 0", key: "svg-0" }],
  ["path", { d: "M7 19l6 0", key: "svg-1" }],
  ["path", { d: "M14 5l-4 14", key: "svg-2" }]
]);

export { IconItalic as default };
//# sourceMappingURL=IconItalic.js.map
